<ng-template #productlineFilter let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-title">Product Line Filtering</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"><i class="fa fa-close"></i></button>
	</div>
	<div class="modal-body">
		<app-chiplist-filter [prods]="prods" (selectionChange)="updateProductLinesFromModal($event)"></app-chiplist-filter>
	</div>
</ng-template>

<ng-container *ngIf="filters">
	<ng-container *ngIf="!issalesman">
		<div class="row text-center">
			<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
				<mat-icon>done</mat-icon> Apply
			</button>
			&nbsp;
			<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
				<mat-icon>restore</mat-icon> Reset
			</button>
		</div>

		<ng-container *ngFor="let filter of filters">

			<h5 class="mb-1 mt-2">{{ filter.name }}</h5>
			<ng-container *ngIf="(filter.name === 'Product Line' || filter.name === 'Manufacturer') && filter.input_type !== 'modal'">
				<div class="row flex-nowrap">
					<div class="col-12">
						<mat-form-field [matTooltip]="'Entering a * will enable/disable visible productlines'">
							<input matInput placeholder="Filter..." [formControl]="linesearchref" />
							<button matSuffix mat-icon-button (click)="resetProdlines()">
								<mat-icon>cancel</mat-icon>
							  </button>
						</mat-form-field>
						
					</div>
				</div>
			</ng-container>
			<ng-container *ngIf="filter.name === 'Product Line' && filter.input_type == 'modal'">
				<div class="m-0 p-0 ol-md-3 col-lg-4">
					<button  class="btn-productline" mat-mini-fab [matBadge]="prods.length" (click)="openProductLines()"><mat-icon>segment</mat-icon></button>
				</div>
			</ng-container>
			<ng-container *ngIf="filter.input_type == 'select'">
			  <div class="row">
				<mat-form-field appearance="outline" class="col-12 custom-mat-select">
				  <mat-label>{{ filter.name }}</mat-label>
				  <mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)" panelClass="custom-mat-panel">
					<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
					  {{ opt.label }}
					</mat-option>
				  </mat-select>
				</mat-form-field>
			  </div>
			</ng-container>


			<ng-container *ngIf="filter.input_type == 'multis'">
				<div class="row">
					<mat-form-field appearance="outline" class="col-12">
						<mat-label>{{ filter.name }}</mat-label>
						<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)" multiple appSelectAll>
							<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
								{{opt.label }}
							</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
			</ng-container>
			<ng-container *ngIf="filter.input_type == 'checkbox'">
				<div class="row">
					<mat-checkbox class="col-6 ellipsis" *ngFor="let opt of filter.options" [value]="opt.value" (change)="updateChecks($event, filter.filter_id)" [checked]="opt.checked" [matTooltip]="opt.label" matTooltipHideDelay="1" #tooltip="matTooltip" (mouseenter)="tooltip.show()" (mouseleave)="tooltip.hide()" matTooltipPosition="above">
						{{opt.label}} 
					</mat-checkbox>
				</div>
			</ng-container>
			<mat-divider></mat-divider>
		</ng-container>
	</ng-container>

	<ng-container *ngIf="issalesman">
		<div class="row m-0 p-0 ">

			<!-- AA -->
			<ng-container *ngIf="config.env.client == 'aaprod' && filters">
				<div class="mt-2 row w-100 m-0 p-0">
					<div class="mt-2 m-0 col-lg-2 col-md-6 p-0 d-none d-lg-inline text-center">
						<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
							<mat-icon>restore</mat-icon>
						</button>
					</div>
					<ng-container *ngFor="let filter of filters">

						<ng-container *ngIf="['select'].includes(filter.input_type)">
							<div class="col-lg-4 col-md-6 m-0 p-0">
								<mat-form-field appearance="outline" class="p-1">
									<mat-label>{{ filter.name }}</mat-label>
									<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)">
										<mat-option value="reset">All</mat-option>
										<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
											{{opt.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</ng-container>

					</ng-container>


					<div class="mt-2 col-6 d-lg-none col-md-6 text-center col-lg-2 mb-2">
						<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
							<mat-icon>restore</mat-icon>
						</button>
					</div>
					<div class="mt-2 m-0 col-6 col-lg-2 col-md-6 p-0  mb-2 text-center" [ngClass]="">
						<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
							<mat-icon>search</mat-icon>
						</button>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="config.env.client == 'hairlines' && filters">
				<div class="mt-2 row w-100 m-0 p-0">
					<div class="mt-2 m-0 col-lg-2 col-md-6 p-0 d-none d-lg-inline text-center">
						<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
							<mat-icon>restore</mat-icon>
						</button>
					</div>

					<ng-container *ngFor="let filter of filters">
						<ng-container *ngIf="['select'].includes(filter.input_type)">
							<div class="col-lg-4 col-md-12 m-0 p-0">
								<mat-form-field appearance="outline" class="p-1">
									<mat-label>{{ filter.name }}</mat-label>
									<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)">
										<mat-option value="reset">All</mat-option>
										<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
											{{opt.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</ng-container>
					</ng-container>

					<div class="mt-2 col-6 d-lg-none col-md-6 text-center col-lg-2 mb-2">
						<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
							<mat-icon>restore</mat-icon>
						</button>
					</div>
					<div class="mt-2 m-0 col-6 col-lg-2 col-md-6 p-0  mb-2 text-center" [ngClass]="">
						<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
							<mat-icon>search</mat-icon>
						</button>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="config.env.client == 'summit' && filters">
				<div class="mt-2 row w-100 m-0 p-0">
					<div class="mt-2 m-0 col-lg-2 col-md-6 p-0 d-none d-lg-inline text-center">
						<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
							<mat-icon>restore</mat-icon>
						</button>
					</div>

					<ng-container *ngFor="let filter of filters">
						<ng-container *ngIf="filter.input_type == 'modal'">
							<div class="m-0 p-0 col-lg-4 col-md-2 col-2 text-left" *ngIf="filter.name === 'Product Line'">
								<button  class="btn-productline" mat-mini-fab [matBadge]="prods.length" (click)="openProductLines()"><mat-icon>segment</mat-icon></button>
							</div>
						</ng-container>
						<ng-container *ngIf="['select'].includes(filter.input_type)">
							<div class="col-lg-4 col-md-10 col-10 m-0 p-0">
								<mat-form-field appearance="outline" class="p-1">
									<mat-label>{{ filter.name }}</mat-label>
									<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)">
										<mat-option value="reset">All</mat-option>
										<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
											{{opt.label }}
										</mat-option>
									</mat-select>
								</mat-form-field>
							</div>
						</ng-container>
					</ng-container>

					<div class="mt-2 col-6 d-lg-none col-md-6 text-center col-lg-2 mb-2">
						<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
							<mat-icon>restore</mat-icon>
						</button>
					</div>
					<div class="mt-2 m-0 col-6 col-lg-2 col-md-6 p-0  mb-2 text-center" [ngClass]="">
						<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
							<mat-icon>search</mat-icon>
						</button>
					</div>
				</div>
			</ng-container>

<!-- 
			<div class="mt-2 col-5 row m-0 p-0">
				<div class="m-0 p-0">
					<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
						<mat-icon>restore</mat-icon>
					</button>
				</div>
				<div class="m-0 p-0" [ngClass]="">
					<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
						<mat-icon>search</mat-icon>
					</button>
				</div>
			</div> -->


			<ng-container *ngFor="let filter of filters">
				<!-- <ng-container *ngIf="filter.input_type == 'modal'">
					<div class="m-0 p-0 text-center col-1" *ngIf="filter.name === 'Product Line'">
						<button  class="btn-productline" mat-mini-fab [matBadge]="prods.length" (click)="openProductLines()"><mat-icon>segment</mat-icon></button>
					</div>
				</ng-container> -->

				<!-- <ng-container *ngIf="['select'].includes(filter.input_type)">
					<div class="col-6 m-0 p-0">
						<mat-form-field appearance="outline" *ngIf="filter.input_type == 'select'">
							<mat-label>{{ filter.name }}</mat-label>
							<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)">
								<mat-option value="reset">All</mat-option>
								<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
									{{opt.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</ng-container> -->


				<!-- <ng-container *ngIf="filter.input_type == 'multis'">
					<div class="col-md-6 ">
						<mat-form-field appearance="outline">
							<mat-label>{{ filter.name }}</mat-label>
							<mat-select [(value)]="filter.default_value" (selectionChange)="updateSearchSelect($event, filter.filter_id)" multiple appSelectAll>
								<mat-option *ngFor="let opt of filter.options" [value]="opt.value">
									{{opt.label }}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
				</ng-container> -->


				<!-- <ng-container *ngIf="filter.input_type == 'checkbox'">
					<div class="m-0 p-0 ol-md-3 col-lg-4">
						<mat-checkbox class="col-6 ellipsis" *ngFor="let opt of filter.options" [value]="opt.value" (change)="updateChecks($event, filter.filter_id)">
							{{opt.label }}
						</mat-checkbox>
					</div>
				</ng-container> -->

				
				<!-- <ng-container *ngIf="filter.input_type == 'modal'">
					<div class="m-0 p-0 col-6 text-center" *ngIf="filter.name === 'Product Line'">
						<button  class="btn-productline" mat-mini-fab [matBadge]="prods.length" (click)="openProductLines()"><mat-icon>segment</mat-icon></button>
					</div>
				</ng-container> -->
			</ng-container>

			
			<!-- <div class="mt-2 col-6">
				<div class="col-6  d-lg-inline col-md-6 text-center mb-2">
					<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
						<mat-icon>restore</mat-icon>
					</button>
				</div>
				<div class="mt-2 col-6 col-md-6 text-center col-lg-2 ">
					<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
						<mat-icon>search</mat-icon>
					</button>
				</div>
			</div> -->
			

			<!-- <div class="mt-2 col-6 d-lg-none col-md-6 text-center col-lg-2 mb-2">
				<button mat-raised-button color="accent" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="accent" (click)="$event.preventDefault(); resetFilters();" class="ml-auto mr-auto">
					<mat-icon>restore</mat-icon>
				</button>
			</div> -->
			<!-- <div class="mt-2 col-6 col-md-6 text-center col-lg-2 ">
				<button mat-raised-button color="primary" (keyup.enter)="$event.preventDefault();" (keydown.enter)="$event.preventDefault();" class="resetButton" color="primary" (click)="$event.preventDefault(); applyFilters();" class="ml-auto mr-auto">
					<mat-icon>search</mat-icon>
				</button>
			</div> -->
		</div>
	</ng-container>
</ng-container>
